import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { crm } from "@/lib/adminApi";

const STATUS_LABEL = { new: "New", contacted: "Contacted", proposal_sent: "Proposal Sent", won: "Won", lost: "Lost" };

export default function Dashboard() {
  const [stats, setStats] = useState(null);
  const [recent, setRecent] = useState([]);

  useEffect(() => {
    crm.stats().then(setStats).catch(() => {});
    crm.list().then((d) => setRecent(d.slice(0, 6))).catch(() => {});
  }, []);

  const cards = [
    { label: "Total Inquiries", value: stats?.total ?? "—" },
    { label: "New", value: stats?.by_status?.new ?? 0 },
    { label: "Proposals Sent", value: stats?.by_status?.proposal_sent ?? 0 },
    { label: "Won", value: stats?.won ?? 0 },
  ];

  return (
    <div data-testid="admin-dashboard">
      <div className="eyebrow mb-3">Overview</div>
      <h1 className="font-display text-5xl text-aria-ink">Studio</h1>

      <div className="mt-10 grid grid-cols-2 gap-5 md:grid-cols-4">
        {cards.map((c) => (
          <div key={c.label} className="border border-aria-travertine bg-aria-ivory p-6">
            <div className="font-display text-5xl text-aria-ink">{c.value}</div>
            <div className="mt-2 text-[0.65rem] uppercase tracking-[0.2em] text-aria-muted">{c.label}</div>
          </div>
        ))}
      </div>

      <div className="mt-12 flex items-center justify-between">
        <h2 className="font-display text-3xl text-aria-ink">Recent inquiries</h2>
        <Link to="/admin/inquiries" className="aria-link text-[0.7rem] uppercase tracking-[0.2em] text-aria-ink/70">Open CRM</Link>
      </div>
      <div className="mt-6 divide-y divide-aria-travertine border-y border-aria-travertine bg-aria-ivory">
        {recent.map((i) => (
          <Link key={i.id} to="/admin/inquiries" className="flex items-center justify-between px-5 py-4 hover:bg-aria-sand">
            <div>
              <div className="font-display text-xl text-aria-ink">{i.name}</div>
              <div className="text-[0.7rem] uppercase tracking-[0.15em] text-aria-muted">{i.event_type || "—"} · {i.location || "—"} · {i.guest_count || "—"}</div>
            </div>
            <span className="text-[0.65rem] uppercase tracking-[0.18em] text-aria-brass">{STATUS_LABEL[i.status] || i.status}</span>
          </Link>
        ))}
        {recent.length === 0 && <div className="px-5 py-8 text-center text-aria-muted">No inquiries yet.</div>}
      </div>
    </div>
  );
}
